import { render, staticRenderFns } from "./addProductDialog.vue?vue&type=template&id=1c3ea55c&scoped=true"
import script from "./addProductDialog.vue?vue&type=script&lang=js"
export * from "./addProductDialog.vue?vue&type=script&lang=js"
import style0 from "./addProductDialog.vue?vue&type=style&index=0&id=1c3ea55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ea55c",
  null
  
)

export default component.exports